// Conditional redirect for /today route based on nav.order.v2 flag
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlags } from '../contexts/FeatureFlagProvider';
import Dashboard from './Dashboard/Dashboard';

const TodayRedirect = () => {
  const { get: getFlag } = useFeatureFlags();
  const navOrderV2 = getFlag('nav.order.v2');

  // If nav V2 is enabled, redirect to /inbox
  if (navOrderV2) {
    return <Navigate to="/inbox" replace />;
  }

  // Otherwise, show the Dashboard component (old Today behavior)
  return <Dashboard />;
};

export default TodayRedirect;